/* import __COLOCATED_TEMPLATE__ from './upload.hbs'; */
var _dec, _class2, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { task } from 'ember-concurrency';
import apiAction from 'vagrant/utils/ec-macros/api-action';
let _class = (_dec = apiAction('providers.create.release.error.message', 'providers.create.release.success.message'), _class2 = class _class2 extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "api", _descriptor, this);
    _initializerDefineProperty(this, "vagrantContext", _descriptor2, this);
    _initializerDefineProperty(this, "allSettled", _descriptor3, this);
  }
  get registryId() {
    return this.vagrantContext.registry?.name;
  }

  // Called whenever an upload finishes or fails
  validateUploads() {
    this.allSettled = this.args.providers.providers.every(p => p.succeeded);
  }
  *release() {
    const registryId = this.vagrantContext.registry?.name;
    const boxId = this.args.box.name;
    const versionId = this.args.version.name;
    if (!registryId || !boxId || !versionId) return;
    yield this.api.vagrant.registryServiceApi.releaseVersion(registryId, boxId, versionId);
    this.args.onRelease?.();
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "api", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "vagrantContext", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "allSettled", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "validateUploads", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "validateUploads"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "release", [task, _dec], Object.getOwnPropertyDescriptor(_class2.prototype, "release"), _class2.prototype), _class2);
export { _class as default };